import React from "react";

export const TimeLoadingLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
      <path
        d="M12 8.3999V11.9999H15.6"
        stroke="#FCB041"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.57961 18.5217L6.14221 15.0435L9.55741 15.9951"
        stroke="#FCB041"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.14222 15.0436C6.88574 16.4759 8.12828 17.5862 9.63491 18.1645C11.1415 18.7428 12.8079 18.7491 14.3188 18.1821C15.8297 17.6151 17.0806 16.5142 17.8348 15.0875C18.5891 13.6608 18.7945 12.0072 18.4122 10.4393C18.0298 8.87144 17.0863 7.49797 15.76 6.57859C14.4337 5.65921 12.8165 5.25764 11.2141 5.4498C9.61182 5.64196 8.13542 6.41454 7.06409 7.62146C5.99277 8.82838 5.40077 10.386 5.40002 11.9998"
        stroke="#FCB041"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
  </svg>
);
